export default class UIRegularEntity extends PIXI.Container {
  constructor() {
    super()
  }
  register(type, object) {
    if(!game.models.JurisdictionModel.get().autospin){
      if(type === 'ImageButton' && object.name === 'autostop'){
        object.renderable = false
      }

      if(type === 'RadioButton' && object._data.name === 'ui-automenu'){
        object.renderable = false
      }

      if(type === 'AutoCountText' && object.name === 'autospin-text'){
        object.renderable = false
      }
    }
  }
}
